<template>
<div class="chapter">
<div class="inner_page">
<a id="page_5"></a>
<div class="img_container">
<img alt="images" src="images/halftitle.jpg"/>
</div>
<p style="page-break-after: always;"></p>
<p class="noindent"> </p>
<a id="page_6"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Halftitle.vue?0b10843a